// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Log$SmartcutsMacros = require("../Log.bs.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var InputLabel$SmartcutsMacros = require("./shared/InputLabel.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var DataDependency$SmartcutsMacros = require("./shared/DataDependency.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");
var SelectionSemantics__InputSelectionSemantics$SmartcutsMacros = require("../SelectionSemantics/SelectionSemantics__InputSelectionSemantics.bs.js");

function labeledAddTextInput_encode(encoder_inputLabel, encoder_addedValue, v) {
  return Js_dict.fromArray([
              [
                "label",
                Decco.optionToJson(encoder_inputLabel, v.label)
              ],
              [
                "addText",
                Curry._1(encoder_addedValue, v.addText)
              ]
            ]);
}

function labeledAddTextInput_decode(decoder_inputLabel, decoder_addedValue, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Decco.optionFromJson(decoder_inputLabel, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var addText = Curry._1(decoder_addedValue, Belt_Option.getWithDefault(Js_dict.get(dict$1, "addText"), null));
    if (addText.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                label: label._0,
                addText: addText._0
              }
            };
    }
    var e = addText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".addText" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringifyLabeledAddTextInput(stringifyAddedValue, stringifyInputLabel, param) {
  return "{label=" + (OptionUtils$SmartcutsMacros.stringify(stringifyInputLabel, param.label) + (", addText=" + (Curry._1(stringifyAddedValue, param.addText) + "}")));
}

function diff_encode(encoder_addedValue, encoder_deletedValue, v) {
  if (v.TAG === /* AddText */0) {
    return [
            "AddText",
            Curry._1(encoder_addedValue, v._0)
          ];
  } else {
    return [
            "DeleteText",
            Curry._1(encoder_deletedValue, v._0)
          ];
  }
}

function diff_decode(decoder_addedValue, decoder_deletedValue, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AddText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_addedValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AddText */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DeleteText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(decoder_deletedValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DeleteText */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringGetGeneral(stringifyAddedValue, stringifyDeletedValue, diff) {
  if (diff.TAG === /* AddText */0) {
    return Curry._1(stringifyAddedValue, diff._0);
  } else {
    return Curry._1(stringifyDeletedValue, diff._0);
  }
}

function stringify(stringifyAddedValue, stringifyDeletedValue, diff) {
  if (diff.TAG === /* AddText */0) {
    return "AddText(" + (Curry._1(stringifyAddedValue, diff._0) + ")");
  } else {
    return Curry._1(stringifyDeletedValue, diff._0);
  }
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "value",
                Decco.stringToJson(v.value)
              ],
              [
                "start",
                Decco.intToJson(v.start)
              ],
              [
                "end_",
                Decco.intToJson(v.end_)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
  if (value.TAG === /* Ok */0) {
    var start = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
    if (start.TAG === /* Ok */0) {
      var end_ = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_"), null));
      if (end_.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  value: value._0,
                  start: start._0,
                  end_: end_._0
                }
              };
      }
      var e = end_._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".end_" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = start._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".start" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function prefixGet(param) {
  return StringUtils$SmartcutsMacros.slice(0, param.start, param.value);
}

function deletedTextGet(param) {
  return StringUtils$SmartcutsMacros.slice(param.start, param.end_, param.value);
}

function suffixGet(param) {
  var value = param.value;
  return StringUtils$SmartcutsMacros.slice(param.end_, value.length, value);
}

function combine(param, param$1) {
  return {
          value: param.value,
          start: param$1.start,
          end_: param.end_
        };
}

function toString(param) {
  return StringUtils$SmartcutsMacros.slice(param.start, param.end_, param.value);
}

function stringify$1(param) {
  return "{value=" + (param.value + (", start=" + (String(param.start) + (", end_=" + (String(param.end_) + "}")))));
}

var DeletedValueForRecording = {
  t_encode: t_encode,
  t_decode: t_decode,
  prefixGet: prefixGet,
  deletedTextGet: deletedTextGet,
  suffixGet: suffixGet,
  combine: combine,
  toString: toString,
  stringify: stringify$1
};

function t_encode$1(v) {
  return diff_encode(Decco.stringToJson, t_encode, v);
}

function t_decode$1(v) {
  return diff_decode(Decco.stringFromJson, t_decode, v);
}

function stringGet(diff) {
  if (diff.TAG === /* AddText */0) {
    return diff._0;
  }
  var match = diff._0;
  return StringUtils$SmartcutsMacros.slice(match.start, match.end_, match.value);
}

function maybeCombine(diffA, diffB) {
  if (diffA.TAG === /* AddText */0) {
    var textToAddA = diffA._0;
    if (diffB.TAG === /* AddText */0) {
      var textToAddB = diffB._0;
      var match = StringUtils$SmartcutsMacros.isNewLine(textToAddA);
      var match$1 = StringUtils$SmartcutsMacros.isNewLine(textToAddB);
      if (match || match$1) {
        return /* KeepBoth */0;
      } else {
        return {
                TAG: /* ReplaceWith */0,
                _0: {
                  TAG: /* AddText */0,
                  _0: textToAddA + textToAddB
                }
              };
      }
    }
    var match$2 = diffB._0;
    var end_ = match$2.end_;
    var start = match$2.start;
    var value = match$2.value;
    var textToDelete = StringUtils$SmartcutsMacros.slice(start, end_, value);
    var numCharsToAdd = textToAddA.length;
    var numCharsToRemove = textToDelete.length;
    if (numCharsToRemove > numCharsToAdd) {
      if (StringUtils$SmartcutsMacros.endsWith(textToDelete, textToAddA)) {
        return {
                TAG: /* ReplaceWith */0,
                _0: {
                  TAG: /* DeleteText */1,
                  _0: {
                    value: value,
                    start: start,
                    end_: end_ - textToAddA.length | 0
                  }
                }
              };
      } else {
        Curry._1(Log$SmartcutsMacros.cmdTypeRecording.warn1, "When combining text diffs and the 2nd diff removes more characters than the 1st diff, then the second diff needs to end with the first diff");
        return /* KeepBoth */0;
      }
    }
    if (StringUtils$SmartcutsMacros.endsWith(textToAddA, textToDelete)) {
      var newTextToAdd = StringUtils$SmartcutsMacros.removeTrailingSuffix(textToAddA, textToDelete);
      if (newTextToAdd === "") {
        return /* RemoveBoth */1;
      } else {
        return {
                TAG: /* ReplaceWith */0,
                _0: {
                  TAG: /* AddText */0,
                  _0: newTextToAdd
                }
              };
      }
    }
    Curry._1(Log$SmartcutsMacros.cmdTypeRecording.warn1, "When combining text diffs and the 2nd deletion diff removes more characters than the 1st addition diff, then the second diff is expected to end with the 1st diff");
    return /* KeepBoth */0;
  }
  var a = diffA._0;
  var end_$1 = a.end_;
  var start$1 = a.start;
  var value$1 = a.value;
  if (diffB.TAG !== /* AddText */0) {
    return {
            TAG: /* ReplaceWith */0,
            _0: {
              TAG: /* DeleteText */1,
              _0: combine(a, diffB._0)
            }
          };
  }
  var textToAdd = diffB._0;
  var textToDelete$1 = StringUtils$SmartcutsMacros.slice(start$1, end_$1, value$1);
  if (StringUtils$SmartcutsMacros.beginsWith(textToDelete$1, textToAdd)) {
    return {
            TAG: /* ReplaceWith */0,
            _0: {
              TAG: /* DeleteText */1,
              _0: {
                value: value$1,
                start: start$1 + textToAdd.length | 0,
                end_: end_$1
              }
            }
          };
  } else {
    return /* KeepBoth */0;
  }
}

function factorOutDynamicVars(valueDiff) {
  var tmp;
  tmp = valueDiff._0;
  var vars = [tmp];
  var factoredValue;
  factoredValue = valueDiff.TAG === /* AddText */0 ? ({
        TAG: /* AddText */0,
        _0: ""
      }) : ({
        TAG: /* DeleteText */1,
        _0: {
          value: "",
          start: 0,
          end_: 0
        }
      });
  return {
          vars: vars,
          factoredValue: factoredValue
        };
}

function substituteInDynamicVars(param) {
  var vars = param.vars;
  if (param.factoredValue.TAG === /* AddText */0) {
    var arg = Js_json.decodeString(Caml_array.get(vars, 0));
    var addText = (function (param) {
          return OptionUtils$SmartcutsMacros.getExn(param, arg);
        })("Expected var to be a string");
    return {
            TAG: /* AddText */0,
            _0: addText
          };
  }
  var deleteText = Caml_array.get(vars, 0);
  return {
          TAG: /* DeleteText */1,
          _0: deleteText
        };
}

var Pack = {
  factorOutDynamicVars: factorOutDynamicVars,
  substituteInDynamicVars: substituteInDynamicVars
};

var ForRecording = {
  DeletedValueForRecording: DeletedValueForRecording,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringGet: stringGet,
  maybeCombine: maybeCombine,
  Pack: Pack
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "recording",
                t_encode(v.recording)
              ],
              [
                "semantics",
                SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.t_encode(v.semantics)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var recording = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recording"), null));
  if (recording.TAG === /* Ok */0) {
    var semantics = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "semantics"), null));
    if (semantics.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                recording: recording._0,
                semantics: semantics._0
              }
            };
    }
    var e = semantics._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".semantics" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = recording._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".recording" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringGet$1(param) {
  return toString(param.recording);
}

function stringify$2(param) {
  return "{recording=" + (stringify$1(param.recording) + (", semantics=" + (SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.stringify(param.semantics) + "}")));
}

var DeletedValueAndSemantics = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringGet: stringGet$1,
  stringify: stringify$2
};

function t_encode$3(v) {
  return diff_encode(DataDependency$SmartcutsMacros.DataRef.t_encode, t_encode$2, v);
}

function t_decode$3(v) {
  return diff_decode(DataDependency$SmartcutsMacros.DataRef.t_decode, t_decode$2, v);
}

function stringGet$2(param) {
  return function (param$1) {
    return stringGetGeneral(param, stringGet$1, param$1);
  };
}

function stringify$3(param) {
  return stringify(DataDependency$SmartcutsMacros.DataRef.stringify, stringify$2, param);
}

function fromRecordingValueDiff(recordingDiff) {
  if (recordingDiff.TAG === /* AddText */0) {
    return {
            TAG: /* AddText */0,
            _0: {
              TAG: /* StaticText */0,
              _0: recordingDiff._0
            }
          };
  }
  var deletedValueForRecording = recordingDiff._0;
  return {
          TAG: /* DeleteText */1,
          _0: {
            recording: deletedValueForRecording,
            semantics: SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.fromSelectionStartAndEndAndValue(deletedValueForRecording.start, deletedValueForRecording.end_, deletedValueForRecording.value)
          }
        };
}

function factorOutDynamicVars$1(valueDiff) {
  if (valueDiff.TAG === /* AddText */0) {
    var factoredDataRef = Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.factorOutDynamicVars, valueDiff._0);
    return {
            vars: factoredDataRef.vars,
            factoredValue: {
              TAG: /* AddText */0,
              _0: factoredDataRef.factoredValue
            }
          };
  }
  var match = valueDiff._0;
  return {
          vars: [match.recording],
          factoredValue: {
            TAG: /* DeleteText */1,
            _0: {
              recording: {
                value: "",
                start: 0,
                end_: 0
              },
              semantics: match.semantics
            }
          }
        };
}

function substituteInDynamicVars$1(param) {
  var factoredValueDiff = param.factoredValue;
  var vars = param.vars;
  if (factoredValueDiff.TAG === /* AddText */0) {
    return {
            TAG: /* AddText */0,
            _0: Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.substituteInDynamicVars, {
                  vars: vars,
                  factoredValue: factoredValueDiff._0
                })
          };
  } else {
    return {
            TAG: /* DeleteText */1,
            _0: {
              recording: Caml_array.get(vars, 0),
              semantics: factoredValueDiff._0.semantics
            }
          };
  }
}

var Pack$1 = {
  factorOutDynamicVars: factorOutDynamicVars$1,
  substituteInDynamicVars: substituteInDynamicVars$1
};

var ForAuthoring = {
  DeletedValueAndSemantics: DeletedValueAndSemantics,
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  stringGet: stringGet$2,
  stringify: stringify$3,
  fromRecordingValueDiff: fromRecordingValueDiff,
  Pack: Pack$1
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "value",
                Decco.stringToJson(v.value)
              ],
              [
                "deletedSemantic",
                SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v.deletedSemantic)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
  if (value.TAG === /* Ok */0) {
    var deletedSemantic = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deletedSemantic"), null));
    if (deletedSemantic.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                value: value._0,
                deletedSemantic: deletedSemantic._0
              }
            };
    }
    var e = deletedSemantic._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".deletedSemantic" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringGet$3(param) {
  return SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.applyToInputValue(param.value, param.deletedSemantic);
}

var OriginalValueWithDeletedSemantic = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringGet: stringGet$3
};

function t_encode$5(v) {
  return diff_encode(DataDependency$SmartcutsMacros.DataRef.t_encode, t_encode$4, v);
}

function t_decode$5(v) {
  return diff_decode(DataDependency$SmartcutsMacros.DataRef.t_decode, t_decode$4, v);
}

function fromAuthoringValueDiff(authoringDiff) {
  if (authoringDiff.TAG === /* AddText */0) {
    return {
            TAG: /* AddText */0,
            _0: authoringDiff._0
          };
  }
  var match = authoringDiff._0;
  return {
          TAG: /* DeleteText */1,
          _0: {
            value: match.recording.value,
            deletedSemantic: Caml_array.get(match.semantics, 0)
          }
        };
}

function arg(semantic) {
  var text = stringGet$3(semantic);
  if (text.TAG === /* Ok */0) {
    return text._0;
  } else {
    return "";
  }
}

function stringGet$4(param) {
  return function (param$1) {
    return stringGetGeneral(param, arg, param$1);
  };
}

function factorOutDynamicVars$2(valueDiff) {
  if (valueDiff.TAG !== /* AddText */0) {
    return {
            vars: [],
            factoredValue: valueDiff
          };
  }
  var factoredDataRef = Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.factorOutDynamicVars, valueDiff._0);
  return {
          vars: factoredDataRef.vars,
          factoredValue: {
            TAG: /* AddText */0,
            _0: factoredDataRef.factoredValue
          }
        };
}

function substituteInDynamicVars$2(param) {
  var factoredValueDiff = param.factoredValue;
  if (factoredValueDiff.TAG === /* AddText */0) {
    return {
            TAG: /* AddText */0,
            _0: Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.substituteInDynamicVars, {
                  vars: param.vars,
                  factoredValue: factoredValueDiff._0
                })
          };
  } else {
    return {
            TAG: /* DeleteText */1,
            _0: factoredValueDiff._0
          };
  }
}

var Pack$2 = {
  factorOutDynamicVars: factorOutDynamicVars$2,
  substituteInDynamicVars: substituteInDynamicVars$2
};

var ForPlayback = {
  OriginalValueWithDeletedSemantic: OriginalValueWithDeletedSemantic,
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  fromAuthoringValueDiff: fromAuthoringValueDiff,
  stringGet: stringGet$4,
  Pack: Pack$2
};

var TextInputValueDiff = {
  InputSelectionSemantics: undefined,
  diff_encode: diff_encode,
  diff_decode: diff_decode,
  stringGetGeneral: stringGetGeneral,
  stringify: stringify,
  ForRecording: ForRecording,
  ForAuthoring: ForAuthoring,
  ForPlayback: ForPlayback
};

function labeledTextInputValueDiff_encode(encoder_valueDiff, encoder_inputLabel, v) {
  return Js_dict.fromArray([
              [
                "label",
                Decco.optionToJson(encoder_inputLabel, v.label)
              ],
              [
                "valueDiff",
                Curry._1(encoder_valueDiff, v.valueDiff)
              ]
            ]);
}

function labeledTextInputValueDiff_decode(decoder_valueDiff, decoder_inputLabel, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Decco.optionFromJson(decoder_inputLabel, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var valueDiff = Curry._1(decoder_valueDiff, Belt_Option.getWithDefault(Js_dict.get(dict$1, "valueDiff"), null));
    if (valueDiff.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                label: label._0,
                valueDiff: valueDiff._0
              }
            };
    }
    var e = valueDiff._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".valueDiff" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringifyLabeledTextInputValueDiff(stringifyValueDiff, stringifyInputLabel, param) {
  return "{label=" + (OptionUtils$SmartcutsMacros.stringify(stringifyInputLabel, param.label) + (", valueDiff=" + (Curry._1(stringifyValueDiff, param.valueDiff) + "}")));
}

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "domElementIdentifierWithSelector",
                DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode(v.domElementIdentifierWithSelector)
              ],
              [
                "labeledTextInputValueDiff",
                labeledTextInputValueDiff_encode(t_encode$1, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.labeledTextInputValueDiff)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementIdentifierWithSelector = DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementIdentifierWithSelector"), null));
  if (domElementIdentifierWithSelector.TAG === /* Ok */0) {
    var labeledTextInputValueDiff = labeledTextInputValueDiff_decode(t_decode$1, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledTextInputValueDiff"), null));
    if (labeledTextInputValueDiff.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                domElementIdentifierWithSelector: domElementIdentifierWithSelector._0,
                labeledTextInputValueDiff: labeledTextInputValueDiff._0
              }
            };
    }
    var e = labeledTextInputValueDiff._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labeledTextInputValueDiff" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = domElementIdentifierWithSelector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementIdentifierWithSelector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$4(param) {
  return "{domElementIdentifierWithSelector: " + (DomElementIdentifierPaired__WithSelector$SmartcutsMacros.stringify(param.domElementIdentifierWithSelector) + (", labeledTextInputValueDiff: " + (stringifyLabeledTextInputValueDiff((function (param) {
                      return stringify((function (s) {
                                    return s;
                                  }), stringify$1, param);
                    }), InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify, param.labeledTextInputValueDiff) + "}")));
}

function factorOutDynamicVars$3(param) {
  var match = param.labeledTextInputValueDiff;
  var match$1 = param.domElementIdentifierWithSelector;
  var match$2 = factorOutDynamicVars(match.valueDiff);
  var match$3 = Selector$SmartcutsMacros.Pack.factorOutDynamicVars(match$1.selector);
  return {
          vars: [
            match$2.vars,
            match$3.vars
          ],
          factoredValue: {
            domElementIdentifierWithSelector: {
              domElementIdentifier: match$1.domElementIdentifier,
              selector: match$3.factoredValue
            },
            labeledTextInputValueDiff: {
              label: match.label,
              valueDiff: match$2.factoredValue
            }
          }
        };
}

function substituteInDynamicVars$3(param) {
  var match = param.factoredValue;
  var match$1 = match.labeledTextInputValueDiff;
  var match$2 = match.domElementIdentifierWithSelector;
  var vars = param.vars;
  var arg = Js_json.decodeArray(Caml_array.get(vars, 0));
  var varsForValueDiff = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected array of vars");
  var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
  var varsForSelector = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expected array of vars");
  return {
          domElementIdentifierWithSelector: {
            domElementIdentifier: match$2.domElementIdentifier,
            selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
                  vars: varsForSelector,
                  factoredValue: match$2.selector
                })
          },
          labeledTextInputValueDiff: {
            label: match$1.label,
            valueDiff: substituteInDynamicVars({
                  vars: varsForValueDiff,
                  factoredValue: match$1.valueDiff
                })
          }
        };
}

var Pack$3 = {
  factorOutDynamicVars: factorOutDynamicVars$3,
  substituteInDynamicVars: substituteInDynamicVars$3
};

var Recording = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  stringify: stringify$4,
  Pack: Pack$3
};

function t_encode$7(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "labeledTextInputValueDiff",
                labeledTextInputValueDiff_encode(t_encode$3, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_encode, v.labeledTextInputValueDiff)
              ]
            ]);
}

function t_decode$7(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var labeledTextInputValueDiff = labeledTextInputValueDiff_decode(t_decode$3, InputLabel$SmartcutsMacros.RecordingAndAuthoring.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledTextInputValueDiff"), null));
    if (labeledTextInputValueDiff.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                selector: selector._0,
                labeledTextInputValueDiff: labeledTextInputValueDiff._0
              }
            };
    }
    var e = labeledTextInputValueDiff._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labeledTextInputValueDiff" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$5(param) {
  return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", labeledTextInputValueDiff: " + (stringifyLabeledTextInputValueDiff(stringify$3, InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify, param.labeledTextInputValueDiff) + "}")));
}

function fromRecordingCommandValue(param) {
  var match = param.labeledTextInputValueDiff;
  return {
          selector: param.domElementIdentifierWithSelector.selector,
          labeledTextInputValueDiff: {
            label: match.label,
            valueDiff: fromRecordingValueDiff(match.valueDiff)
          }
        };
}

function updateSelector(f, param) {
  return {
          selector: Curry._1(f, param.selector),
          labeledTextInputValueDiff: param.labeledTextInputValueDiff
        };
}

function getInputIdentifier(commandIndex, param) {
  return Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + String(commandIndex);
}

function factorOutDynamicVars$4(param) {
  var match = param.labeledTextInputValueDiff;
  var match$1 = factorOutDynamicVars$1(match.valueDiff);
  var match$2 = Selector$SmartcutsMacros.Pack.factorOutDynamicVars(param.selector);
  return {
          vars: [
            match$1.vars,
            match$2.vars
          ],
          factoredValue: {
            selector: match$2.factoredValue,
            labeledTextInputValueDiff: {
              label: match.label,
              valueDiff: match$1.factoredValue
            }
          }
        };
}

function substituteInDynamicVars$4(param) {
  var match = param.factoredValue;
  var match$1 = match.labeledTextInputValueDiff;
  var vars = param.vars;
  var arg = Js_json.decodeArray(Caml_array.get(vars, 0));
  var varsForValueDiff = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected array of vars");
  var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
  var varsForSelector = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expected array of vars");
  return {
          selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
                vars: varsForSelector,
                factoredValue: match.selector
              }),
          labeledTextInputValueDiff: {
            label: match$1.label,
            valueDiff: substituteInDynamicVars$1({
                  vars: varsForValueDiff,
                  factoredValue: match$1.valueDiff
                })
          }
        };
}

var Pack$4 = {
  factorOutDynamicVars: factorOutDynamicVars$4,
  substituteInDynamicVars: substituteInDynamicVars$4
};

function maybeGetDataRef(param) {
  var valueDiff = param.labeledTextInputValueDiff.valueDiff;
  if (valueDiff.TAG === /* AddText */0) {
    return valueDiff._0;
  }
  
}

function maybeUpdateDataRef(dataRef, cmdVal) {
  var labeledTextInputValueDiff = cmdVal.labeledTextInputValueDiff;
  var valueDiff = labeledTextInputValueDiff.valueDiff;
  var tmp;
  tmp = valueDiff.TAG === /* AddText */0 ? ({
        TAG: /* AddText */0,
        _0: dataRef
      }) : valueDiff;
  return {
          selector: cmdVal.selector,
          labeledTextInputValueDiff: {
            label: labeledTextInputValueDiff.label,
            valueDiff: tmp
          }
        };
}

var Authoring = {
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  stringify: stringify$5,
  fromRecordingCommandValue: fromRecordingCommandValue,
  updateSelector: updateSelector,
  getInputIdentifier: getInputIdentifier,
  Pack: Pack$4,
  maybeGetDataRef: maybeGetDataRef,
  maybeUpdateDataRef: maybeUpdateDataRef
};

function t_encode$8(v) {
  return Js_dict.fromArray([
              [
                "selector",
                Selector$SmartcutsMacros.selector_encode(v.selector)
              ],
              [
                "labeledTextInputValueDiff",
                labeledTextInputValueDiff_encode(t_encode$5, InputLabel$SmartcutsMacros.t_encode, v.labeledTextInputValueDiff)
              ]
            ]);
}

function t_decode$8(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var selector = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selector"), null));
  if (selector.TAG === /* Ok */0) {
    var labeledTextInputValueDiff = labeledTextInputValueDiff_decode(t_decode$5, InputLabel$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledTextInputValueDiff"), null));
    if (labeledTextInputValueDiff.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                selector: selector._0,
                labeledTextInputValueDiff: labeledTextInputValueDiff._0
              }
            };
    }
    var e = labeledTextInputValueDiff._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labeledTextInputValueDiff" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = selector._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".selector" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromAuthoringCommandValue(param) {
  var match = param.labeledTextInputValueDiff;
  return {
          selector: param.selector,
          labeledTextInputValueDiff: {
            label: Belt_Option.flatMap(match.label, (function (inputLabel) {
                    var match = Caml_array.get(inputLabel.labels, 0).derivedVia;
                    if (match >= 2) {
                      return ;
                    } else {
                      return InputLabel$SmartcutsMacros.fromRecordingAndAuthoring(inputLabel);
                    }
                  })),
            valueDiff: fromAuthoringValueDiff(match.valueDiff)
          }
        };
}

function selectorGet(param) {
  return [param.selector];
}

function stringify$6(param) {
  return "{selector: " + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + (", labeledTextInputValueDiff: " + (stringifyLabeledTextInputValueDiff((function (param) {
                      return "_";
                    }), InputLabel$SmartcutsMacros.stringify, param.labeledTextInputValueDiff) + "}")));
}

function maybeGetDataRef$1(param) {
  var valueDiff = param.labeledTextInputValueDiff.valueDiff;
  if (valueDiff.TAG === /* AddText */0) {
    return valueDiff._0;
  }
  
}

function maybeUpdateDataRef$1(dataRef, cmdVal) {
  var labeledTextInputValueDiff = cmdVal.labeledTextInputValueDiff;
  var valueDiff = labeledTextInputValueDiff.valueDiff;
  var tmp;
  tmp = valueDiff.TAG === /* AddText */0 ? ({
        TAG: /* AddText */0,
        _0: dataRef
      }) : valueDiff;
  return {
          selector: cmdVal.selector,
          labeledTextInputValueDiff: {
            label: labeledTextInputValueDiff.label,
            valueDiff: tmp
          }
        };
}

function factorOutDynamicVars$5(param) {
  var match = param.labeledTextInputValueDiff;
  var match$1 = factorOutDynamicVars$2(match.valueDiff);
  var match$2 = Selector$SmartcutsMacros.Pack.factorOutDynamicVars(param.selector);
  return {
          vars: [
            match$1.vars,
            match$2.vars
          ],
          factoredValue: {
            selector: match$2.factoredValue,
            labeledTextInputValueDiff: {
              label: match.label,
              valueDiff: match$1.factoredValue
            }
          }
        };
}

function substituteInDynamicVars$5(param) {
  var match = param.factoredValue;
  var match$1 = match.labeledTextInputValueDiff;
  var vars = param.vars;
  var arg = Js_json.decodeArray(Caml_array.get(vars, 0));
  var varsForValueDiff = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected array of vars");
  var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
  var varsForSelector = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expected array of vars");
  return {
          selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
                vars: varsForSelector,
                factoredValue: match.selector
              }),
          labeledTextInputValueDiff: {
            label: match$1.label,
            valueDiff: substituteInDynamicVars$2({
                  vars: varsForValueDiff,
                  factoredValue: match$1.valueDiff
                })
          }
        };
}

var Pack$5 = {
  factorOutDynamicVars: factorOutDynamicVars$5,
  substituteInDynamicVars: substituteInDynamicVars$5
};

var Playback = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  fromAuthoringCommandValue: fromAuthoringCommandValue,
  selectorGet: selectorGet,
  stringify: stringify$6,
  maybeGetDataRef: maybeGetDataRef$1,
  maybeUpdateDataRef: maybeUpdateDataRef$1,
  Pack: Pack$5
};

var CommandValue = {
  labeledAddTextInput_encode: labeledAddTextInput_encode,
  labeledAddTextInput_decode: labeledAddTextInput_decode,
  stringifyLabeledAddTextInput: stringifyLabeledAddTextInput,
  TextInputValueDiff: TextInputValueDiff,
  labeledTextInputValueDiff_encode: labeledTextInputValueDiff_encode,
  labeledTextInputValueDiff_decode: labeledTextInputValueDiff_decode,
  stringifyLabeledTextInputValueDiff: stringifyLabeledTextInputValueDiff,
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function stringify$7(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return "Variable";
    } else {
      return "NotVariable";
    }
  } else {
    return "VariableWithinEnums(enums)";
  }
}

function updateVariableWithinEnums(f, strategy) {
  if (typeof strategy === "number") {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected VariableWithinEnums");
  } else {
    return /* VariableWithinEnums */{
            _0: Curry._1(f, strategy._0)
          };
  }
}

var Strategy = {
  stringify: stringify$7,
  updateVariableWithinEnums: updateVariableWithinEnums
};

function stringify$8(param) {
  var originalLabeledAddText = param.originalLabeledAddText;
  var param$1 = DataDependency$SmartcutsMacros.DataRef.stringify;
  var arg = OptionUtils$SmartcutsMacros.map(param.selectedLabelIndex, (function (prim) {
          return String(prim);
        }));
  return "{targetLocator, originalLabeledAddText: " + ((function (param$2) {
                return stringifyLabeledAddTextInput(param$1, param$2, originalLabeledAddText);
              })(InputLabel$SmartcutsMacros.RecordingAndAuthoring.stringify) + (", selectedLabelIndex: " + ((function (param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                  })("Undefined") + (", playbackFormLabel: " + (param.playbackFormLabel + (", strategy: " + (stringify$7(param.strategy) + "}")))))));
}

function isDynamic(param) {
  var strategy = param.strategy;
  return strategy !== 0;
}

function updateConfigWithAuthoringCommandValue(commandValue, config) {
  var match = commandValue.labeledTextInputValueDiff;
  var addText = match.valueDiff;
  if (addText.TAG === /* AddText */0) {
    return {
            targetLocator: config.targetLocator,
            originalLabeledAddText: {
              label: match.label,
              addText: addText._0
            },
            selectedLabelIndex: config.selectedLabelIndex,
            playbackFormLabel: config.playbackFormLabel,
            strategy: config.strategy
          };
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: AddTextInputConfig cannot be paired with valueDiff DeleteText(_)");
  }
}

var AddTextInputConfig = {
  Strategy: Strategy,
  stringify: stringify$8,
  isDynamic: isDynamic,
  updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue
};

function isDynamic$1(param) {
  return false;
}

function stringify$9(param) {
  return "deleteTextInputConfig";
}

function updateConfigWithAuthoringCommandValue$1(commandValue, config) {
  var match = commandValue.labeledTextInputValueDiff.valueDiff;
  if (match.TAG === /* AddText */0) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: DeleteTextInputConfig cannot be paired with valueDiff AddText(_)");
  } else {
    return {
            targetLocator: config.targetLocator,
            label: config.label,
            selectedLabelIndex: config.selectedLabelIndex,
            originalDelete: match._0.recording,
            semantics: config.semantics,
            config: config.config
          };
  }
}

var DeleteTextInputConfig = {
  isDynamic: isDynamic$1,
  stringify: stringify$9,
  updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue$1
};

function stringify$10(config) {
  if (config.TAG === /* AddTextInputConfig */0) {
    return "AddTextInputConfig(" + (stringify$8(config._0) + ")");
  } else {
    return "DeleteTextInputConfig(_)";
  }
}

function fromAuthoringCommandValue$1(cmdVal) {
  var match = cmdVal.labeledTextInputValueDiff;
  var addText = match.valueDiff;
  var label = match.label;
  var targetLocator = cmdVal.selector;
  if (addText.TAG === /* AddText */0) {
    var arg = Belt_Option.flatMap(label, InputLabel$SmartcutsMacros.RecordingAndAuthoring.getLabelText);
    return {
            TAG: /* AddTextInputConfig */0,
            _0: {
              targetLocator: targetLocator,
              originalLabeledAddText: {
                label: label,
                addText: addText._0
              },
              selectedLabelIndex: label !== undefined && label.labels.length !== 0 ? 0 : undefined,
              playbackFormLabel: (function (param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                  })("[Add a label]"),
              strategy: /* NotVariable */0
            }
          };
  }
  var match$1 = addText._0;
  var semantics = match$1.semantics;
  return {
          TAG: /* DeleteTextInputConfig */1,
          _0: {
            targetLocator: targetLocator,
            label: label,
            selectedLabelIndex: label !== undefined && label.labels.length !== 0 ? 0 : undefined,
            originalDelete: match$1.recording,
            semantics: semantics,
            config: Caml_array.get(semantics, 0)
          }
        };
}

function applyToAuthoringCommandValueToGetPlaybackCommandValue(commandValue, config) {
  var playbackCommand = fromAuthoringCommandValue(commandValue);
  var init = playbackCommand.labeledTextInputValueDiff;
  var tmp;
  var exit = 0;
  var sharedRootDepth;
  var labels;
  var selectedLabelIndex;
  if (config.TAG === /* AddTextInputConfig */0) {
    var match = config._0;
    var match$1 = match.originalLabeledAddText.label;
    if (match$1 !== undefined) {
      var selectedLabelIndex$1 = match.selectedLabelIndex;
      if (selectedLabelIndex$1 !== undefined) {
        sharedRootDepth = match$1.sharedRootDepth;
        labels = match$1.labels;
        selectedLabelIndex = selectedLabelIndex$1;
        exit = 1;
      } else {
        tmp = undefined;
      }
    } else {
      tmp = undefined;
    }
  } else {
    var match$2 = config._0;
    var match$3 = match$2.label;
    if (match$3 !== undefined) {
      var selectedLabelIndex$2 = match$2.selectedLabelIndex;
      if (selectedLabelIndex$2 !== undefined) {
        sharedRootDepth = match$3.sharedRootDepth;
        labels = match$3.labels;
        selectedLabelIndex = selectedLabelIndex$2;
        exit = 1;
      } else {
        tmp = undefined;
      }
    } else {
      tmp = undefined;
    }
  }
  if (exit === 1) {
    tmp = {
      selector: Caml_array.get(labels, selectedLabelIndex).selector,
      labelText: Caml_array.get(labels, selectedLabelIndex).labelText,
      sharedRootDepth: sharedRootDepth
    };
  }
  return {
          selector: playbackCommand.selector,
          labeledTextInputValueDiff: {
            label: tmp,
            valueDiff: init.valueDiff
          }
        };
}

var AuthoringConfig = {
  AddTextInputConfig: AddTextInputConfig,
  DeleteTextInputConfig: DeleteTextInputConfig,
  stringify: stringify$10,
  fromAuthoringCommandValue: fromAuthoringCommandValue$1,
  applyToAuthoringCommandValueToGetPlaybackCommandValue: applyToAuthoringCommandValueToGetPlaybackCommandValue
};

function t_encode$9(v) {
  return Js_dict.fromArray([
              [
                "targetLocator",
                Selector$SmartcutsMacros.selector_encode(v.targetLocator)
              ],
              [
                "originalLabeledAddText",
                labeledAddTextInput_encode(InputLabel$SmartcutsMacros.t_encode, DataDependency$SmartcutsMacros.DataRef.t_encode, v.originalLabeledAddText)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ],
              [
                "enums",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(Decco.stringToJson, param);
                      }), v.enums)
              ]
            ]);
}

function t_decode$9(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
  if (targetLocator.TAG === /* Ok */0) {
    var originalLabeledAddText = labeledAddTextInput_decode(InputLabel$SmartcutsMacros.t_decode, DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalLabeledAddText"), null));
    if (originalLabeledAddText.TAG === /* Ok */0) {
      var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
      if (playbackFormLabel.TAG === /* Ok */0) {
        var enums = Decco.optionFromJson((function (param) {
                return Decco.arrayFromJson(Decco.stringFromJson, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "enums"), null));
        if (enums.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    targetLocator: targetLocator._0,
                    originalLabeledAddText: originalLabeledAddText._0,
                    playbackFormLabel: playbackFormLabel._0,
                    enums: enums._0
                  }
                };
        }
        var e = enums._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".enums" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = playbackFormLabel._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".playbackFormLabel" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = originalLabeledAddText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".originalLabeledAddText" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = targetLocator._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".targetLocator" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function fromAuthoringConfig(param) {
  var strategy = param.strategy;
  var selectedLabelIndex = param.selectedLabelIndex;
  var match = param.originalLabeledAddText;
  var match$1;
  if (typeof strategy === "number") {
    match$1 = strategy !== 0 ? [
        match.addText,
        undefined
      ] : Util$SmartcutsMacros.logAndRaiseJsError("Can't create param descriptor for non-dynamic authoring config");
  } else {
    var enums = strategy._0;
    var arg = Belt_Array.get(enums, 0);
    var defaultText = {
      TAG: /* StaticText */0,
      _0: (function (param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg);
          })("Expect enums to have at least 1 value")
    };
    match$1 = [
      defaultText,
      enums
    ];
  }
  return {
          targetLocator: param.targetLocator,
          originalLabeledAddText: {
            label: Belt_Option.flatMap(match.label, (function (param) {
                    if (selectedLabelIndex === undefined) {
                      return ;
                    }
                    var labels = param.labels;
                    return {
                            selector: Caml_array.get(labels, selectedLabelIndex).selector,
                            labelText: Caml_array.get(labels, selectedLabelIndex).labelText,
                            sharedRootDepth: param.sharedRootDepth
                          };
                  })),
            addText: match$1[0]
          },
          playbackFormLabel: param.playbackFormLabel,
          enums: match$1[1]
        };
}

var AddTextInputParam = {
  t_encode: t_encode$9,
  t_decode: t_decode$9,
  fromAuthoringConfig: fromAuthoringConfig
};

var ParamDescriptor = {
  AddTextInputParam: AddTextInputParam
};

function t_encode$10(v) {
  return Js_dict.fromArray([
              [
                "targetLocator",
                Selector$SmartcutsMacros.selector_encode(v.targetLocator)
              ],
              [
                "labeledAddTextInput",
                labeledAddTextInput_encode(InputLabel$SmartcutsMacros.t_encode, DataDependency$SmartcutsMacros.DataRef.t_encode, v.labeledAddTextInput)
              ]
            ]);
}

function t_decode$10(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var targetLocator = Selector$SmartcutsMacros.selector_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "targetLocator"), null));
  if (targetLocator.TAG === /* Ok */0) {
    var labeledAddTextInput = labeledAddTextInput_decode(InputLabel$SmartcutsMacros.t_decode, DataDependency$SmartcutsMacros.DataRef.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "labeledAddTextInput"), null));
    if (labeledAddTextInput.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                targetLocator: targetLocator._0,
                labeledAddTextInput: labeledAddTextInput._0
              }
            };
    }
    var e = labeledAddTextInput._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".labeledAddTextInput" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = targetLocator._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".targetLocator" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$11(param) {
  return "{targetLocator, labeledAddTextInput: " + (stringifyLabeledAddTextInput(DataDependency$SmartcutsMacros.DataRef.stringify, InputLabel$SmartcutsMacros.stringify, param.labeledAddTextInput) + "}");
}

function fromParamDescriptor(param) {
  var match = param.originalLabeledAddText;
  return {
          targetLocator: param.targetLocator,
          labeledAddTextInput: {
            label: match.label,
            addText: match.addText
          }
        };
}

function toCommandValueForPlayback(param) {
  var match = param.labeledAddTextInput;
  return {
          selector: param.targetLocator,
          labeledTextInputValueDiff: {
            label: match.label,
            valueDiff: {
              TAG: /* AddText */0,
              _0: match.addText
            }
          }
        };
}

function valueForFormInput(param) {
  var addText = param.labeledAddTextInput.addText;
  if (addText.TAG === /* StaticText */0) {
    return addText._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unimplemented - valueForFormInput for non static text");
  }
}

function paramValueBuilderFromParamDescriptor(param) {
  var originalLabeledAddText = param.originalLabeledAddText;
  var targetLocator = param.targetLocator;
  return function (value) {
    return {
            targetLocator: targetLocator,
            labeledAddTextInput: {
              label: originalLabeledAddText.label,
              addText: value
            }
          };
  };
}

var AddTextInputParam$1 = {
  t_encode: t_encode$10,
  t_decode: t_decode$10,
  stringify: stringify$11,
  fromParamDescriptor: fromParamDescriptor,
  toCommandValueForPlayback: toCommandValueForPlayback,
  valueForFormInput: valueForFormInput,
  paramValueBuilderFromParamDescriptor: paramValueBuilderFromParamDescriptor
};

var PlaybackParamValue = {
  AddTextInputParam: AddTextInputParam$1
};

exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* Log-SmartcutsMacros Not a pure module */
